import { readableStepName, escapeEmptyDetail } from '../../utils/utils';
import DetailItem from '../../components/DetailItem/DetailItem';
import {StakeholdersDetails} from "../../components/StakeholdersDetails/StakeholdersDetails";
import React from "react";

export const AssetRegistrationStepModel = (step) => {
    return (
    <>
      <p className='details-title'>
        <b>
          { readableStepName(step['@type']) }
        </b>
      </p>
      <DetailItem title='Title' content={escapeEmptyDetail(step.title)} />
      <DetailItem title='Description' content={escapeEmptyDetail(step.description)} />
        <StakeholdersDetails oldStakeholders={step.oldCustodians} />
        <DetailItem title='Registry Account Id' content={escapeEmptyDetail(step.registryAccountId)} copy={step.registryAccountId} />
      <DetailItem title='Registry Account Name' content={escapeEmptyDetail(step.registryAccountname)} />
      <DetailItem title='Registry' content={escapeEmptyDetail(step.registry)} />
      <DetailItem title='Registry Provider' content={escapeEmptyDetail(step.registryProvider)} />
      <DetailItem title='Registry Environment' content={escapeEmptyDetail(step.registryEnvironment)} />
      <DetailItem title='Registry API Version' content={escapeEmptyDetail(step.registryAPIVersion)} />
    </>
  );
};
